import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import SearchOverlay from "./SearchOverlay";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧情", to: "/category/story" },
  { label: "演员", to: "/category/cast" },
  { label: "片段", to: "/category/clip" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg text-background-50">
            母
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-base font-semibold text-foreground-900">年轻的母亲</span>
            <span className="hidden text-[11px] text-foreground-400 sm:block">影视剧专题站</span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm transition hover:bg-primary-50 hover:text-primary-700 ${
                  isActive ? "text-primary-600" : "text-foreground-600"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <button
            type="button"
            onClick={() => setSearchOpen(true)}
            aria-label="搜索"
            className="flex h-9 items-center gap-2 rounded-full border border-background-300/80 bg-background-50 px-3 text-sm text-foreground-500 transition hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-search-line"></i>
            <span className="hidden lg:inline">搜索</span>
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300/80 text-foreground-700 transition hover:border-primary-300 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="animate-fade-in border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <ul className="flex flex-col">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-md px-3 py-3 text-sm transition ${
                      isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </header>
  );
}